import autobind from 'autobind-decorator';
import { extendObservable, computed, toJS } from 'mobx';
import { ScoreUtil } from '../../../../../../../../common/utils/scoreUtil';
import { timeUtils } from '../../../../../../../../common/utils/timeUtil';

@autobind
class LoLMatchRelativeRecordVsRecordModel {
  constructor(data) {
    extendObservable(this, data);
  }

  @computed
  get getTeamData() {
    const { home, away } = this;

    const game = {
      teams: {
        home,
        away,
        league: { name: this.leagueName },
        period: this.scores.length,
      },
    };

    return ScoreUtil.getTeamScore(game, this.status, 'LOL', this.scores.length);
  }

  @computed
  get teams() {
    const { home, away } = this;

    return { home, away };
  }

  @computed
  get date() {
    return timeUtils.timeFormatMonthDay(`${this.gdate}T${this.gtime}`);
  }
}

export default LoLMatchRelativeRecordVsRecordModel;
